export default "__VITE_ASSET__3b5aec98__"